import React from 'react';
import { Card } from 'react-bootstrap';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const CaudalChart = ({ data }) => {
  // Formatea los datos para la gráfica
  const chartData = data.map(item => ({
    hora: new Date(item.fecha + 'T' + item.hora).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
    caudal: item.caudal
  }));

  return (
    <Card className="mb-4">
      <Card.Header as="h6">Caudal Durante el Día (m³/h)</Card.Header>
      <Card.Body>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="hora" />
            <YAxis label={{ value: 'Caudal (m³/h)', angle: -90, position: 'insideLeft' }} />
            <Tooltip />
            <Legend />
            <Line 
              type="monotone" 
              dataKey="caudal" 
              stroke="#0088FE" 
              name="Caudal" 
              dot={{ r: 3 }} 
              activeDot={{ r: 8 }} 
            />
          </LineChart>
        </ResponsiveContainer>
      </Card.Body>
    </Card>
  );
};

export default CaudalChart;